<div class="ambassador-app">
  <header class="app-header navbar navbar-expand-lg navbar-dark bg-dark" aria-label="Primary navigation">
    <div class="container-fluid">
      <a class="navbar-brand" href="https://yachtapp.net">
        <img src="assets/yachtapp-logo.png" alt="YachtApp" height="40" />
      </a>

      <button class="navbar-toggler" type="button" aria-label="Toggle navigation" [attr.aria-expanded]="isMobileNavOpen"
        (click)="toggleMobileNav()">
        <span class="navbar-toggler-icon" aria-hidden="true"></span>
      </button>

      <nav class="navbar-nav ms-auto" [class.show]="isMobileNavOpen" aria-label="Ambassador navigation">
        <a class="nav-link" routerLink="/ambassadors" routerLinkActive="active"
          (click)="closeMobileNav()">Ambassadors</a>
        <a class="nav-link" routerLink="/how-it-works" routerLinkActive="active" (click)="closeMobileNav()">How It
          Works</a>
        <a class="nav-link" routerLink="/commission-plans" routerLinkActive="active"
          (click)="closeMobileNav()">Commissions</a>
        <a class="nav-link" routerLink="/who-should-join" routerLinkActive="active" (click)="closeMobileNav()">Who
          Should Join</a>
        <a class="nav-link" routerLink="/marketing-resources" routerLinkActive="active"
          (click)="closeMobileNav()">Resources</a>
        <a class="nav-link" routerLink="/faq" routerLinkActive="active" (click)="closeMobileNav()">FAQ</a>

        <ng-container *ngIf="user$ | async as user; else loginLinkTemplate">
          <li class="nav-item userbox" [class.show]="isUserDropdownOpen">
            <button class="userbox-toggle ms-2" type="button" aria-label="User menu"
              [attr.aria-expanded]="isUserDropdownOpen" (click)="toggleUserDropdown()">
              <span class="profile-picture"><img [src]="user.photoURL || fallbackProfilePhoto"
                  [alt]="user.displayName || user.email || 'Ambassador user'"></span>
              <span class="profile-info d-none d-lg-flex"><span class="name">{{ user.displayName || user.email ||
                  'Ambassador' }}</span><span class="role">Ambassador</span></span>
              <i aria-hidden="true" class="bi bi-chevron-down custom-caret"></i>
            </button>
            <div class="userbox-menu" [class.show]="isUserDropdownOpen">
              <ul>
                <li><a routerLink="/dashboard" (click)="closeNavigationMenus()"><i
                      class="bi bi-speedometer2"></i>Dashboard</a></li>
                <li><a routerLink="/visits" (click)="closeNavigationMenus()"><i
                      class="bi bi-graph-up-arrow"></i>Visits</a></li>
                <li><a routerLink="/referrals" (click)="closeNavigationMenus()"><i
                      class="bi bi-person-plus"></i>Referrals</a></li>
                <li><a routerLink="/commissions" (click)="closeNavigationMenus()"><i
                      class="bi bi-cash-coin"></i>Commissions</a></li>
                <li><a routerLink="/payouts" (click)="closeNavigationMenus()"><i
                      class="bi bi-wallet2"></i>Payouts</a></li>
                <li><a routerLink="/settings" (click)="closeNavigationMenus()"><i
                      class="bi bi-sliders"></i>Settings</a></li>
                <li><a routerLink="/resources" (click)="closeNavigationMenus()"><i class="bi bi-files"></i>Resources</a>
                </li>
                <li><button type="button" class="logout-btn" (click)="logout()"><i
                      class="bi bi-power"></i>Logout</button></li>
              </ul>
            </div>
          </li>
        </ng-container>
        <ng-template #loginLinkTemplate>
          <a class="nav-link btn btn-primary" routerLink="/login" routerLinkActive="active" (click)="closeMobileNav()">Login</a>
        </ng-template>
      </nav>
    </div>
  </header>

  <main class="ambassador-shell">
    <router-outlet></router-outlet>
  </main>

  <footer class="bg-dark text-white pt-4 pb-2 mt-0">
    <div class="container text-center text-md-start">
      <div class="row">
        <div class="col-md-3 mb-3">
          <h5>YachtApp Ambassadors</h5>
          <p>Your trusted boat maintenance solution for awesome sailing.</p>
        </div>
        <div class="col-md-3 mb-3">
          <h5>Links</h5>
          <ul class="list-unstyled">
            <li><a class="text-white text-decoration-none" routerLink="/ambassadors">Ambassadors</a></li>
            <li><a class="text-white text-decoration-none" routerLink="/login">Login</a></li>
            <li><a class="text-white text-decoration-none" routerLink="/signup">Register</a></li>
          </ul>
        </div>
        <div class="col-md-3 mb-3">
          <h5>Program</h5>
          <p>Apply, get reviewed by YachtApp, then share your approved referral link with yacht owners and operators.
          </p>
        </div>
        <div class="col-md-3 mb-3">
          <h5>Need help?</h5>
          <ul class="list-unstyled">
            <li><a class="text-white text-decoration-none" routerLink="/faq">Program FAQ</a></li>
            <li><a class="text-white text-decoration-none" routerLink="/reset-password">Reset your password</a></li>
            <li><a class="text-white text-decoration-none" href="https://yachtapp.net/contact">Contact YachtApp</a></li>
          </ul>
          <h5>Follow us</h5>
          <a class="text-white text-decoration-none" href="https://www.linkedin.com/company/135205900/"
            aria-label="YachtApp on LinkedIn">LinkedIn</a>
        </div>
      </div>
      <hr class="border-light">
      <nav class="footer-policy-links" aria-label="Legal information">
        <a class="text-white text-decoration-none" href="https://yachtapp.net/privacy-policy">Privacy policy</a>
        <a class="text-white text-decoration-none" href="https://yachtapp.net/terms-and-conditions">Terms and conditions</a>
      </nav>
      <div class="text-center"><small>&copy; {{ currentYear }} YachtApp Ambassadors. All rights reserved.</small></div>
    </div>
  </footer>
</div>
